import { Action } from 'PyzShopUi/scripts/shop-ui/includes/enhanced-reducer';
import { Reducer } from 'react';
import { IProductReviewActionState } from 'PyzShopUi/scripts/product-review/interfaces';
import {
    beginGetProductReviewLoading,
    endGetProductReviewLoading,
    updateProductReviewState
} from 'PyzShopUi/scripts/product-review/actions/getReview';
import { doUpdatePageLoading, doUpdateProductReviewState } from 'PyzShopUi/scripts/product-review/reducer/getReview';
import { doSetPagination } from 'PyzShopUi/scripts/product-review/reducer/pagination';
import { setPagination } from 'PyzShopUi/scripts/product-review/actions/pagination';
import { setSort } from 'PyzShopUi/scripts/shop-ui/components/search-page/actions/sort';
import { setLanguage } from 'PyzShopUi/scripts/product-review/actions/language';
import {doSetLanguages} from 'PyzShopUi/scripts/product-review/reducer/setLanguages';
import { doSetSort } from 'PyzShopUi/scripts/product-review/reducer/sort';
import {setRating} from 'PyzShopUi/scripts/product-review/actions/rating';
import {doSetRating} from 'PyzShopUi/scripts/product-review/reducer/setRating';

export const productReviewReducer: Reducer<IProductReviewActionState, Action<any>> = (state, action) => {
    switch (action.type) {
        case updateProductReviewState.type:
            return doUpdateProductReviewState(state, action.payload);
        case beginGetProductReviewLoading.type:
            return doUpdatePageLoading(state, true);
        case endGetProductReviewLoading.type:
            return doUpdatePageLoading(state, false);
        case setPagination.type:
            return doSetPagination(state, action.payload);
        case setSort.type:
            return doSetSort(state, action.payload);
        case setLanguage.type:
            return doSetLanguages(state, action.payload);
        case setRating.type:
            return doSetRating(state, action.payload);
        default:
            return state;
    }
};
